import React, { Component } from "react";

export default class Modal extends Component {
  constructor(props) {
    super(props);
  }

  closeModal() {
    this.props.close();
  }

  render() {
    return (
      <div className="modal--wrapper" onClick={() => this.closeModal()}>
        <div
          className="modal modal--small"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={() => this.closeModal()}
            className="button button--close"
          >
            <span>&#10005;</span>
          </button>
          <div className="modal--inside">{this.props.children}</div>
        </div>
      </div>
    );
  }
}
